/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 11.05.2016.
 */

import Persons from './persons';

export default Persons;


// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/Persons/index.js